import type {
  FeatureFlagAdminResponse,
  FeatureFlagApiClientApplication,
  FeatureFlagApiRolloutTarget,
  FeatureFlagTableRow,
  FeatureFlagTableRolloutScope,
  FeatureFlagTargetClient,
} from '../../../types/features/featureFlags';
import { formatDateTimeMMDDYYYY } from '../../../utils/formatUtils';

const API_CLIENT_TO_TARGET_CLIENT: Record<FeatureFlagApiClientApplication, FeatureFlagTargetClient> = {
  react_native: 'mobile_app',
  webapp: 'webapp',
};

const CLIENT_LABELS: Record<FeatureFlagTargetClient, string> = {
  mobile_app: 'Mobile App',
  webapp: 'Web App',
};

const getRolloutLabel = (
  rolloutScope: FeatureFlagTableRolloutScope,
  rolloutTarget: FeatureFlagApiRolloutTarget,
): string => {
  if (rolloutScope === 'all') {
    return 'All';
  }

  return rolloutTarget === 'users' ? 'Selected Users' : 'Selected Stores';
};

export const mapApiClientApplicationToTargetClient = (
  clientApplication: FeatureFlagApiClientApplication,
): FeatureFlagTargetClient => API_CLIENT_TO_TARGET_CLIENT[clientApplication];

export const mapFeatureFlagResponseToTableRow = (
  featureFlag: FeatureFlagAdminResponse,
): FeatureFlagTableRow => {
  const client = mapApiClientApplicationToTargetClient(featureFlag.client_application);
  const rolloutTarget = featureFlag.rollout_target;
  const rolloutScope = featureFlag.rollout_scope;
  const assignmentCount = rolloutTarget === 'users'
    ? featureFlag.assigned_user_count || 0
    : featureFlag.assigned_store_count;
  const isAllRollout = rolloutScope === 'all' || rolloutTarget === 'all';

  return {
    assignmentCount: isAllRollout ? 0 : assignmentCount,
    assignmentCountLabel: isAllRollout ? '-' : String(assignmentCount),
    client,
    clientLabel: CLIENT_LABELS[client],
    description: featureFlag.description || '',
    displayName: featureFlag.display_name,
    featureKey: featureFlag.key,
    globalEnabled: featureFlag.global_enabled,
    id: featureFlag.id,
    lastUpdated: formatDateTimeMMDDYYYY(featureFlag.updated_at, { fallback: '-' }),
    rolloutLabel: getRolloutLabel(rolloutScope, rolloutTarget),
    rolloutScope,
    rolloutTarget,
  };
};
